<template lang="pug">
section.hero(ref="seg")
  .container
    .columns
      .column.is-12.has-text-centered
        h2.title.is-size-3 Seguridad
        h3.subtitle.is-size-4 Contamos con certificaciones de la Norma Oficial Mexicana y de la Agencia de Seguridad, Energía y Ambiente.
    .columns.is-multiline.content.is-mobile
      .column.is-12-mobile.is-4-tablet.is-4-desktop.is-4-widescreen.is-4-fullhd
        .card
          .card-content
            .media
              .media-left
                figure.image.is-96x96
                  img(:src="require('@/assets/Nom.png')")
              .media-content
                p.title.is-size-5
                  | NOM-015-SECRE-2013
                p.subtitle.is-size-5
                  | Norma Oficial Mexicana
            .content
              .media-content
                p.is-size-4
                  | Diseño, seguridad, operación, mantenimiento de sistemas de almacenamiento de gas licuado de petróleo.
      .column.is-12-mobile.is-4-tablet.is-4-desktop.is-4-widescreen.is-4-fullhd
        .card
          .card-content
            .media
              .media-left
                figure.image.is-96x96
                  img(:src="require('@/assets/Nom.png')")
              .media-content
                p.title.is-size-5
                  | NOM-016
                p.subtitle.is-size-5
                  | Norma Oficial Mexicana
            .content
              .media-content
                p.is-size-4
                  | Norma oficial que regula la calidad del combustible en México.
      .column.is-12-mobile.is-4-tablet.is-4-desktop.is-4-widescreen.is-4-fullhd
        .card
          .card-content
            .media
              .media-left
                figure.image.is-96x96
                  img(:src="require('@/assets/calidadAmbiental.png')")
              .media-content
                p.title.is-size-5
                  | Certificado de Calidad Ambiental
                p.subtitle.is-size-5
                  | Agencia Nacional de Seguridad Industrial y de Protección al Medio Ambiente del Sector Hidrocarburos.
            .content
              .media-content
                p.is-size-4
                  | Nivel de desempeño, otorgado por la ASEA, Agencia de Seguridad, Energía y Ambiente.
</template>

<script>
  export default {
    name: "Seguridad",
    props: {
      seccionSel: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
      }
    },
    watch: {
      seccionSel() {
        if (this.seccionSel === 'seg') {
          this.$refs['seg'].scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .hero {
    margin-bottom: 50px;
  }
  .content {
    margin-top: 20px;
    justify-items: stretch;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/landing_Componentes/Seguridad.vue